import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../ts/ServerApi/types/actionParams';
import { IDataRoleActions } from '../types/IDataRoleActions';

export class GetDataRoleActionsRequest extends Request<ISingleIdParams, IDataRoleActions> {
  constructor(id: string) {
    super('getDataRoleActions', { id: id });
  }
}
